// extracted by mini-css-extract-plugin
module.exports = {"container":"ClassesAndSpecsPage_container__2_4U6"};